import { render } from "./AddCalendarEvent.vue?vue&type=template&id=8dea90d0&ts=true"
import script from "./AddCalendarEvent.ts?vue&type=script&lang=ts&external"
export * from "./AddCalendarEvent.ts?vue&type=script&lang=ts&external"

import "./AddCalendarEvent.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__